/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Deg
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface SocialMediaSettings {  
  facebookLink: string;  
  twitterLink: string;
  instagramLink: string;
  vkLink: string;
  youtubeLink: string;
  telegramLink: string;
}